import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_NO.json';
import audios from './ASTROLOGY_AUDIOS_NO.json';

export const ASTROLOGY_DATA_NO: ServiceData = {
  articles,
  audios,
};
